﻿import { ManufacturerTypes } from '../models/enums';

export abstract class StandardsUtil{

    public static standardCoaUrl(manufacturerId: ManufacturerTypes, catalogNumber: string, batch: string) {
        let coaUrl = "";

        switch (manufacturerId) {
            case ManufacturerTypes.EP:
                coaUrl = `https://crs.edqm.eu/db/4DCGI/View=${catalogNumber}`
                break;
            case ManufacturerTypes.BP:
                coaUrl = ``
                break;
            case ManufacturerTypes.ACUS:
                coaUrl = `https://docs.accustandard.com/docshare/coa/COA_${catalogNumber}_${batch}.pdf`
                break;
            case ManufacturerTypes.ABUS:
                coaUrl = `https://www.absolutestandards.com/coa/20000/Part${catalogNumber}-Lot${batch}.pdf`
                break;
            case ManufacturerTypes.IOVS:
                coaUrl = `https://www.inorganicventures.com/coa/Letterhead/IV/${catalogNumber}_${batch}.pdf`
                break;
            case ManufacturerTypes.RTKS:
                coaUrl = `https://www.restek.com/api/documentaccess/get/refstdCert/${catalogNumber}/${batch}.pdf`
                break;
            case ManufacturerTypes.SGAS:
                coaUrl = `https://www.sigmaaldrich.com/certificates/sapfs/PROD/sap/certificate_pdfs/COFA/Q14/${catalogNumber}-BULK${batch}.pdf`
                break;
            case ManufacturerTypes.USP:
                coaUrl = `https://static.usp.org/pdf/EN/referenceStandards/certificates/${catalogNumber}-${batch}.pdf`
                break;
        }

        return coaUrl;
    }	
}
